import React, { PureComponent } from 'react';
import './OrRule.css';

export default class OrRule extends PureComponent {
  render() {
    return (
      <div className="OrRule">
        <hr className="OrRule-bars" />
        <span className="OrRule-text">
          or
        </span>
        <hr className="OrRule-bars" />
     </div>
    );
  }
}
